import React from 'react';
import { arc } from 'd3';
import PropTypes from 'prop-types';

const Circular = ({
  percentage = 0,
  radius,
  trackWidth,
  trackColor,
  progressFillColor,
  textColor,
}) => {
  const svgBoxSize = radius * 2;
  const svgTranslateSize = svgBoxSize / 2;

  const arcCreator = arc()
    .startAngle(0)
    .outerRadius(radius)
    .innerRadius(radius - trackWidth)
    .cornerRadius(trackWidth / 2);

  const renderProgressArc = (value) =>
    arcCreator({
      endAngle: 2 * Math.PI * value,
    });

  return (
    <svg height={svgBoxSize} width={svgBoxSize}>
      <g transform={`translate(${svgTranslateSize}, ${svgTranslateSize})`}>
        <path d={renderProgressArc(1)} fill={trackColor} />
      </g>
      <g transform={`translate(${svgTranslateSize}, ${svgTranslateSize})`}>
        <path
          d={renderProgressArc(percentage / 100)}
          fill={progressFillColor}
        />
        <text textAnchor="middle" dy="5" color={textColor}>
          {`${percentage}%`}
        </text>
      </g>
    </svg>
  );
};

Circular.propTypes = {
  percentage: PropTypes.number,
  radius: PropTypes.number,
  trackWidth: PropTypes.number,
  trackColor: PropTypes.string,
  progressFillColor: PropTypes.string,
};

export default Circular;
